export const enum AnnualReportListViewState {
    ACTIVE = 'Active',
    ARCHIVED = 'Archived',
}
